// src/Utils/announcementsPermissions.js

import { isPrivileged } from "./permissionsCore";

/**
 * Tiedotteiden hallinta (luonti / muokkaus / poisto)
 * - v1: privileged (hallitus / isännöitsijä / admin)
 */
export function canManageAnnouncements(user, companyId) {
  return isPrivileged(user, companyId);
}

/**
 * Oikeus luoda uusi tiedote.
 */
export function canCreateAnnouncement(user, companyId) {
  return isPrivileged(user, companyId);
}

/**
 * Oikeus poistaa tiedote.
 * (Jos haluat myöhemmin: esim. vain admin tai vain creator + privileged.)
 */
export function canDeleteAnnouncement(user, companyId) {
  return isPrivileged(user, companyId);
}
